module.exports = __webpack_public_path__ + "media/Ringtone.mp3";